// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"c8f74839","70":"b8fd78ff","431":"f730d697","496":"be71e6b6","724":"416db5f2","961":"df7a2bd4","985":"cea1ec8f"}[chunkId] + ".chunk.js";
};